module.exports = __webpack_public_path__ + "static/img/20250617.ce66481.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news/20250617.jpg
// module id = YJOE
// module chunks = 99